module.exports = __webpack_public_path__ + "img/4.f24ed370.jpg";